import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { CreateThemeDto, ThemeDto } from '../../themes-grid/model/types';

const THEMES_URL = `/api/admin/themes/`;

interface UpdateThemeParams {
	uuid: string;
	request: Partial<CreateThemeDto>;
}

export const useCreateTheme = () => {
	const queryClient = useQueryClient();
	return useMutation<ThemeDto, any, CreateThemeDto>(
		'themes',
		async request => {
			const { data: response } = await axios.post(THEMES_URL, request);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('themes');
			},
		}
	);
};

export const useUpdateTheme = () => {
	const queryClient = useQueryClient();
	return useMutation<ThemeDto, any, UpdateThemeParams>(
		'themes',
		async ({ uuid, request }) => {
			const { data: response } = await axios.patch(
				`${THEMES_URL}${uuid}`,
				request
			);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('themes');
			},
		}
	);
};

export const useDeleteTheme = () => {
	const queryClient = useQueryClient();
	return useMutation<ThemeDto, any, string>(
		'themes',
		async uuid => {
			const { data: response } = await axios.delete(`${THEMES_URL}${uuid}`);
			return response;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries('themes');
			},
		}
	);
};
